var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"visible":_vm.visible,"size":_vm.size,"title":_vm.title,"hide-footer":true},on:{"hide":_vm.hide}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }